import {apolloClient} from "../../plugins/apollo-client";
import CREATE_CONTACT from "../../graphql/contacts/create.gql";
import CREATE_CONTACT_AND_AUTO_CONNECT from "../../graphql/contacts/createAndAutoConnect.gql";
import LIST_CONTACT from "../../graphql/contacts/list.gql";
import DELETE_CONTACT from "../../graphql/contacts/delete.gql";
import GET_CONTACT_BY_RECORD_ID from "../../graphql/contacts/getByRecordId.gql";

const listContacts = () =>
  apolloClient
    .query({
      query: LIST_CONTACT,
      fetchPolicy: 'no-cache'
    })
    .then(({data}) => data)
    .then(({contacts}) => contacts);

const createContact = (contactForm) =>
  apolloClient
    .mutate({
      mutation: CREATE_CONTACT,
      variables: contactForm
    })
    .then(({data}) => data)
    .then(({contact}) => contact);

const createContactAndAutoConnect = (contactForm) =>
  apolloClient
    .mutate({
      mutation: CREATE_CONTACT_AND_AUTO_CONNECT,
      variables: {contact: contactForm}
    })
    .then(({data}) => data)
    .then(({autoConnect}) => autoConnect);

const deleteContact = (id) =>
  apolloClient
    .mutate({
      mutation: DELETE_CONTACT,
      variables: {id}
    })
    .then(({data}) => data)
    .then(({contact}) => contact);

const getContactByRecordId = (recordId) =>
  apolloClient
    .query({
      query: GET_CONTACT_BY_RECORD_ID,
      variables: {recordId},
      fetchPolicy: 'no-cache'
    })
    .then(({data}) => data)
    .then(({contact}) => contact);

export {
  createContact,
  createContactAndAutoConnect,
  listContacts,
  deleteContact,
  getContactByRecordId
}
